$(function() {

  $('#map').each(function() {
    var pos = new google.maps.LatLng(55.59498, 13.00501);
    var opt = {
      zoom: 15,
      center: pos,
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      mapTypeControl: false
    };
    var map = new google.maps.Map(document.getElementById('map'), opt);
    var pin = new google.maps.Marker({
        position: pos,
        map: map,
        title: 'Justine & Juliette'
    });
  });

  $('h2, .gvheader h1').each(function() {
    $(this).wrapInner('<span/>');
    $(this).css('backgroundPosition', $(this).find('span').width() + 10 + 'px center');
  });

  $('a.popup').fancybox({
    overlayColor: '#000',
    padding: 9
  });

  $('#intro-slideshow').cycle();
  
  $('.submenu').each(function(index, element) {
  	$(element).find('> li').sort(function(a, b) {
      return $(a).text() > $(b).text() ? 1 : - 1
    }).appendTo(element)
  })
  
  $('#product-form').on('submit', function(e) {
   	var form = $(this)
    var variant = form.find('.variants option:selected')
    if (variant.data('inventory-management') == 'shopify' && variant.data('inventory-policy') == 'deny' && variant.data('quantity') < 1) {
      alert('Den valda produkten är tillfälligt slut.')
      e.preventDefault()
      e.stopPropagation()
    }
  })
  /* If mobile browser, prevent click on parent nav item from redirecting to URL */
  if(is_touch_device()) {	

	$('#menu li > ul').each(function (index, elem) {
	  $(elem).prev('a').click(function(event) {
  	    event.preventDefault();
	  });
	});
  }
  
});

function is_touch_device() {
  return !!('ontouchstart' in window);
}